import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Sitemap } from '../../config';
import { history } from '../../history';
import { AlertAction, AuthAction } from '../../actions';
import { RayForm, RayFormValidation } from '../../components/common';
import { AppHeader } from '../../components/common';
import { ROUTES } from '../../config/routes';
import { isAdminPathname } from '../../lib/isAdminPathname';

const UpdatePassword = ({ AlertError, AlertOk, isAlertClose }) => {

    const [t] = useTranslation();
    const [inputs, setInputs] = useState({
        password: '',
        newpassword: '',
        confirmnewpassword: ''
    });
    const [submitted, setSubmitted] = useState(false);
    const [result, setResult] = useState(false);
    const [errors, setErrors] = useState([]);
    // 관리자 레이아웃(/Admin/*)에서 열렸으면 내 계정 복귀 주소도 관리자 쪽이다.
    const isAdmin = isAdminPathname(window.location.pathname);
    const myInfoPath = isAdmin ? ROUTES.ADMIN_MY_INFO : "/MyInfo";

    const { password, newpassword, confirmnewpassword } = inputs;

    const form_controls = [
        {
            title: "", items: [
                {
                    type: "password",
                    name: "password",
                    required: true,
                    skipStrength: true, // U-04: 현재 비밀번호는 강도 검사 제외(약한 기존 비밀번호도 변경 가능)
                    label: t('auth.field.currentPassword'),
                    val: password
                },
                {
                    type: "password",
                    name: 'newpassword',
                    required: true,
                    label: t('auth.field.newPassword'),
                    val: newpassword
                },
                {
                    type: "password",
                    name: "confirmnewpassword",
                    required: true,
                    label: t('auth.field.confirmPassword'),
                    val: confirmnewpassword
                },
            ]
        }
    ]

    useEffect(() => {
        if (result)
            history.push(myInfoPath);
    }, [result]);

    const handleChangeData = (e) => {
        const { name, value } = e.target;
        setInputs(inputs => ({ ...inputs, [name]: value }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const errValidate = RayFormValidation(form_controls, inputs);
        if (errValidate.length > 0) {
            setErrors(errValidate);
        } else {
            if (newpassword != confirmnewpassword) {                
                setErrors([{ name: "confirmnewpassword", msg: "Please check password" }]);
                return;
            }
            setSubmitted(true);
            AuthAction.UpdatePasswordModify(inputs).then((ret) => {
                if (ret) {
                    setResult(true);
                    AlertOk(t('common.message.success.saved'));
                } else {
                    setSubmitted(false);
                    AlertError("Fail");
                }
            });
        }
    }

    return (
        <>
            {!isAdmin && <div className="appHeader no-border">
                <AppHeader title="Update Password" />
                <div className="right">
                </div>
            </div>}
            <div id="appCapsule">
                <RayForm controls={form_controls} handleChangeData={handleChangeData} errors={errors} isForm={true} />
                <div className="section">
                    <button onClick={handleSubmit} className="btn btn-primary btn-block">{t('auth.button.updatePassword')}</button>
                    {isAdmin && <button type="button" onClick={() => history.push(myInfoPath)} className="btn btn-dark btn-block mt-1">{t('common.button.cancel')}</button>}
                </div>
            </div>
        </>
    );
}

const mapState = state => {
    return { isAlertClose: state.AlertReducer.isClose };
}

const mapDispatch = dispatch => ({
    AlertError: message => dispatch(AlertAction.Error(message)),
    AlertOk: message => dispatch(AlertAction.Success(message)),
})

export default connect(mapState, mapDispatch)(UpdatePassword);